import { Flex } from 'onefaceui-react-components';
import styled from 'styled-components';

export const FormContainer = styled(Flex)`
  flex-direction: column;
  gap: 8px;

  fieldset {
    width: 100%;
  }

  input {
    width: 100%;
    height: 30px !important;
  }

  .generic-modal__modal-body-container {
    padding: 0;
  }

  label {
    margin-bottom: 2px;
  }

  .oneface-select div:nth-child(4) {
    position: relative !important;
    left: 0;
    top: 0;
  }
`;
